import styled from 'styled-components'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import { FaChevronDown } from 'react-icons/fa'

const ProjectsFaqStyled = styled.section`
  background: var(--white);
  color: var(--neutral100);
  padding-top: 64px;
  padding-bottom: 64px;
  summary {
    display: flex;
    align-items: center;
    max-width: 374px;
    margin: 0 auto;
    justify-content: space-between;
    margin-bottom: 8px;
    cursor: pointer;
    outline: none;
    list-style: none;
  }
  summary::marker, summary::-webkit-details-marker {
    display: none;
    color: transparent;
  }
  svg {
    transition: .2s ease-in-out;
  }
  details[open] {
    summary svg {
      transform: rotate(180deg);
    }
  }
  li {
    margin: 24px 0;
    font-size: 16px;
    line-height: 24px;
  }
  p {
    color: var(--neutral90);
  }
  a {
    font-weight: bold;
  }
  .faq-email:hover {
    text-decoration: underline;
  }
  .faq-post {
    color: var(--secondary);
    transition: 0.3s ease-in color;
    text-decoration: underline;
    font-weight: 600;
    &:hover {
      color: var(--secondaryHover);
    }
    &:hover {
      color: var(--secondaryActive);
    }
  }
  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 128px;
  }
`

function ProjectsFaq() {
  return (
    <ProjectsFaqStyled aria-label="Preguntas Frecuentes">
      <Wrapper maxWidth="600">
        <details open>
          <summary>
            <Typography small="headline6" large="headline5" as="h2">
              Preguntas mas frecuentes
            </Typography>
            <FaChevronDown color="var(--secondary)" size="20px" />
          </summary>
          <ul>
            <li>
              <h4>¿El código viene incluido?</h4>
              <p>
                No, la idea base de este producto es que practiques tus habilidades, desde definir el Stack adecuado, el que sepas o el que quieras poner a prueba y así crees el mejor portafolio y que la falta de buen diseño no limite tus habilidades de excelente Frontend.
              </p>
            </li>
            <li>
              <h4>Política de cancelación</h4>
              <p>
                Si usas menos de 2 proyectos en 30 días y no te gusta te devolvemos tu dinero si nos escribes a
                {' '}
                <a href="growth@leonidasesteban.com">me@leonidasesteban.com</a>
                . Esta política no aplica en renovaciones de tu suscripción
              </p>
            </li>
            <li>
              <h4>¿La suscripción incluye acceso a los cursos?</h4>
              <p>
                No, los cursos y talleres están incluidos en la suscripción total.
              </p>
            </li>
            <li>
              <h4>¿La suscripción se renueva de forma automática?</h4>
              <p>
                Todos los modelos de suscripción como Netflix o el nuestro cuentan con una renovación automática para no interrumpir de forma abrupta el acceso a sus benficios. Si no deseas que se renueve escríbenos a
                {' '}
                <a href="growth@leonidasesteban.com">me@leonidasesteban.com</a>
                {' '}
                con mucho gusto te ayudamos
                .
              </p>
            </li>
            <li>
              <h4>¿Hay tratos con empresas/escuelas?</h4>
              <p>
                Escríbeme a
                <a href="mailto:me@leonidasesteban.com" className="faq-email"> me@leonidasesteban.com </a>
                y cuéntame cómo podemos trabajar juntos, me interesa que más personas puedan ser parte.
              </p>
            </li>
            <li>
              <h4>¿Puedo usar los diseños de manera comercial?</h4>
              <p>
                Preferimos que los uses para tu portafolio y para practicar, si algún diseño se adapta a alguna aplicación comercial que quieras desarrollar escríbenos para estar al tanto a
                <a href="mailto:me@leonidasesteban.com" className="faq-email"> me@leonidasesteban.com</a>
              </p>
            </li>
            <li>
              <h4>¿Me dan feedback? ¿Quién o cómo revisan los proyectos? </h4>
              <p>
                Tenemos una serie de integraciones para que profesores, expertos, el equipo, la comunidad y yo revisemos tu proyecto y poder darte feedback que recibas por texto en Discord y mail. Aprende cómo enviar tu proyecto a revisión.
                <a href="https://leonidasesteban.com/blog/como-usar-proyectos-en-3-pasos" target="_blank" rel="noopener noreferrer" className="faq-post"> Ir al post.</a>
              </p>
            </li>
            <li>
              <h4>¿Cómo funciona la descarga de proyectos?</h4>
              <p>
                Al ser suscriptor de /Proyectos puedes descargar una base de assets para iniciar tu proyecto desde la página de cada proyecto que incluye: Archivo con el diseño editable en Figma, fuentes personalizadas si son necesarias, un readme.md con indicaciones y buenas prácticas a tener en cuenta.
              </p>
            </li>
          </ul>
        </details>
      </Wrapper>
    </ProjectsFaqStyled>
  )
}

export default ProjectsFaq
